// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 4;
}

.modal-main {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-width: 400px;
  width: 33vw;
  max-width: 800px;
  max-height: 90vh;
  padding: 16px;
  border-radius: 8px;
  background: #fff;
  text-align: center;
  z-index: 5;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
@media (max-width: 950px) {
  .modal-main {
    min-width: 500px;
  }
}
@media (max-width: 800px) {
  .modal-main {
    min-width: 400px;
  }
}

.modal.display-block {
  display: flex;
}

.display-none {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/ClientControlPage/Modals/addPersonModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AACF;;AA4BA;EACE,eAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,0CAAA;AAzBF;AA2BE;EAjBF;IAkBI,gBAAA;EAxBF;AACF;AA0BE;EArBF;IAsBI,gBAAA;EAvBF;AACF;;AA0BE;EACE,aAAA;AAvBJ;;AA0BE;EACE,aAAA;AAvBJ","sourcesContent":[".modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 4;\n}\n\n// .modal-main {\n//   position: fixed;\n//   left: 281px;\n//   top: 90px;\n//   min-width: 632px;\n//   height: 750px;\n//   width: 30vw;\n//   max-width: 800px;\n//   padding: 16px;\n//   padding-top: 24px;\n//   border-radius: 8px;\n//   text-align: center;\n//   z-index: 5;\n\n//   @media (max-width: 950px) {\n//     min-width: 500px;\n//   }\n\n//   @media (max-width: 800px) {\n//     min-width: 400px;\n//   }\n//   @media (max-height: 900px) {\n//     // height: 400px;\n//     overflow-y: scroll;\n//   }\n// }\n.modal-main {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  min-width: 400px;\n  width: 33vw;\n  max-width: 800px;\n  max-height: 90vh;\n  padding: 16px;\n  border-radius: 8px;\n  background: #fff;\n  text-align: center;\n  z-index: 5;\n  overflow-y: auto;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n\n  @media (max-width: 950px) {\n    min-width: 500px;\n  }\n\n  @media (max-width: 800px) {\n    min-width: 400px;\n  }\n}\n  \n  .modal.display-block {\n    display: flex;\n  }\n\n  .display-none {\n    display: none;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal`,
	"modal-main": `modal-main`,
	"display-block": `display-block`,
	"display-none": `display-none`
};
export default ___CSS_LOADER_EXPORT___;
